import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useEditFolder = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();

  return useMutation(
    trpc.folders.update.mutationOptions({
      onSuccess: (_data) => {
        toast.success("Folder edited successfully");
        queryClient.invalidateQueries({
          queryKey: trpc.folders.getUserFolders.queryKey(),
        });
      },
      onError: (error) => {
        console.error("Failed to edit folder", error);
        toast.error(error.message);
      },
    }),
  );
};
